import { render, staticRenderFns } from "./RelatorioStatus.vue?vue&type=template&id=2ff70197&scoped=true"
import script from "./RelatorioStatus.vue?vue&type=script&lang=js"
export * from "./RelatorioStatus.vue?vue&type=script&lang=js"
import style0 from "./RelatorioStatus.vue?vue&type=style&index=0&id=2ff70197&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff70197",
  null
  
)

export default component.exports